import { Accordion, Form, Tab, Tabs } from "react-bootstrap";
import { TopBar } from "../../shared/topBar/TopBar";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { ToastContainer } from "react-toastify";
import { UrlPath } from "../../../config/routeConfig";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { Pricing } from "../../Portfolio/Pricing";
import { AssetAUMList } from "../../Portfolio/AssetAum";
import { EmailMarketings } from "../../investor/emailNotifications/EmailMarketings"
import { Tracking } from "../../investor/emailNotifications/Tracking"
import { getEmailIdListAPI, getEmailTemplateListAPI } from "../../../config/apiConfig";
import { sbaAxios } from "../../utils/sbaAxios";

export const EmailMarketing = () => {
    const [selectedTab,setSelectedTab]=useState("EmailMarketing")
    useEffect(()=>{
        document.title='Email Marketing';
    },[]);

    const Level = [{ BreadCrumb: "CRM >", Routes: `${UrlPath.Investor}` },{ BreadCrumb: "Email Marketing", Routes: `${UrlPath.EmailMarketing}` }]
    return <>
        <TopBar label={"Email Marketing"} />
        <div  className="mainContentData">
            <BreadCrumbs Levels={Level} />
            <div className="p-3">
                <Tabs id="uncontrolled-tab-example" className="ms-3 borderbtm0" activeKey={selectedTab} onSelect={(k) => setSelectedTab(k)} >
                    <Tab eventKey="EmailMarketing" title="Email Marketing"   
       >
                        <div className="p-3 bg-white life-science rounded">
                      {selectedTab==="EmailMarketing" &&       <EmailMarketings />}
                        </div>
                    </Tab>
                    <Tab eventKey="Tracking" title="Tracking" >
                        <div className="p-3 bg-white life-science rounded">
                      {selectedTab==="Tracking" &&       <Tracking />}
                        </div>
                    </Tab>
                </Tabs>
            </div>
        </div>
        <ToastContainer />
    </>
};
